import { IconButton } from '@creditornot/cb-button';
import { Menu } from '@creditornot/cb-icons';
import { colors, cbSemanticCssVars, WoltLogo } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import styled from 'styled-components';

import UserDropdown from 'modules/header/components/UserDropdown';

const MobileHeaderContainer = styled.div`
  display: flex;
  background-color: ${cssThemedValue({ light: colors.pepper4, dark: colors.pepper100 })};
  fill: ${cbSemanticCssVars.textSecondary};
  justify-content: space-between;
  align-items: center;
  padding-block: 32px;
  padding-inline: 8px;
  position: absolute;
  width: 100vw;
  margin-block-end: 80px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

const MenuIconContainer = styled(IconButton)`
  margin: 4px;
`;

type MobileHeaderProps = {
  isCollapsed: boolean;
  setIsCollapsed: (isCollapsed: boolean) => void;
};

const WoltSidebarLogo = styled(WoltLogo)`
  height: 24px;
  padding: 2px 0;

  fill: ${cbSemanticCssVars.textPrimary};
`;

const MobileHeader = ({ isCollapsed, setIsCollapsed }: MobileHeaderProps) => {
  const toggleSidebarOpen = () => setIsCollapsed(!isCollapsed);
  return (
    <MobileHeaderContainer>
      <MenuIconContainer variant="black" size="small" onClick={toggleSidebarOpen}>
        <Menu />
      </MenuIconContainer>
      <WoltSidebarLogo />
      <UserDropdown />
    </MobileHeaderContainer>
  );
};

export default MobileHeader;
